import classNames from 'classnames';
import { motion } from 'framer-motion';
import { FC, useState } from 'react';
import { Article, Reference } from '~/types';

import ArticleReference from '../ArticleReference/ArticleReference';
import styles from './SingleArticleReferences.module.scss';

interface Props {
  article: Article;
  references: Reference[];
  referenceId?: string;
}
const SingleArticleReferences: FC<Props> = ({
  references,
  article,
  referenceId,
}) => {
  const [showAll, setShowAll] = useState(false);

  const filteredReferences = referenceId
    ? [
        {
          id: article.id,
          url: article.reference_url,
          reference_title: article.title,
          reference_image_url: article.media?.thumbnail?.responsive ?? null,
        },
        ...references.filter((ref) => ref.id !== Number(referenceId)),
      ]
    : references;

  return (
    !!filteredReferences.length && (
      <>
        <h2 className={styles.title}>References</h2>
        <div className={styles.references}>
          {filteredReferences.slice(0, 3).map((reference) => (
            <ArticleReference
              articleUrl={article.slug}
              key={reference.id}
              reference={reference}
              isInSingle
            />
          ))}
        </div>
        {filteredReferences.length > 3 && (
          <>
            <motion.div
              initial={{ height: 0 }}
              animate={{ height: showAll ? 'auto' : 0 }}
              transition={{ duration: 0.2, ease: 'easeOut' }}
              className={styles.hiddenReferences}
            >
              {filteredReferences.slice(3).map((reference) => (
                <ArticleReference
                  key={reference.id}
                  articleUrl={article.slug}
                  reference={reference}
                  isInSingle
                />
              ))}
            </motion.div>
            <div className={styles.buttonHolder}>
              <button
                className={classNames(styles.toggleButton, {
                  [styles.active]: showAll,
                })}
                onClick={() => setShowAll((prev) => !prev)}
              >
                Show {showAll ? 'Less' : 'More'}
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M17 10.5L12 15.5L7 10.5'
                    stroke='currentColor'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              </button>
            </div>
          </>
        )}
      </>
    )
  );
};

export default SingleArticleReferences;
